import { render, staticRenderFns } from "./status-report-table.vue?vue&type=template&id=06f13df2&scoped=true"
import script from "./status-report-table.vue?vue&type=script&lang=js"
export * from "./status-report-table.vue?vue&type=script&lang=js"
import style0 from "./status-report-table.vue?vue&type=style&index=0&id=06f13df2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f13df2",
  null
  
)

export default component.exports